import { render, staticRenderFns } from "./ActiveRoutes.vue?vue&type=template&id=35556f70&scoped=true&"
import script from "./ActiveRoutes.vue?vue&type=script&lang=js&"
export * from "./ActiveRoutes.vue?vue&type=script&lang=js&"
import style0 from "./ActiveRoutes.vue?vue&type=style&index=0&id=35556f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35556f70",
  null
  
)

export default component.exports